import React from "react";
import Navbar from "../components/Navbar";

const Manage = () => {
  document.body.style = "background-color: #FAFCFE";
  return (
    <>
      <header>
        <Navbar userName={"Jack"} />
      </header>
      <main className="main">
        <h1>Manage - WIP</h1>
      </main>
    </>
  );
};

export default Manage;
